
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 34 36","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#0A203D","stroke-width":"2","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M9.85 31.406a7.988 7.988 0 0013.342 0M27.386 16.521v-4.656c0-6-4.864-10.865-10.865-10.865-6 0-10.865 4.864-10.865 10.865v4.656c0 5.2-4.656 6.364-4.656 9.313 0 2.561 5.976 4.656 15.521 4.656 9.546 0 15.522-2.095 15.522-4.656 0-2.949-4.657-4.113-4.657-9.313z"}})])])
          )
        }
      }
    